import LocalStorage from 'app/utils/localStorage';

const isEqual = (obj1, obj2) => JSON.stringify(obj1) === JSON.stringify(obj2);

const isEmpty = (obj) => Object.keys(obj).length === 0;

const isNull = (obj) =>
  obj === null ||
  obj === undefined ||
  (typeof obj === 'string' && obj.trim() === '');

const isNumeric = (str, base = 10) => !Number.isNaN(parseInt(str, base));

const isError = (e) =>
  e &&
  e.stack &&
  e.message &&
  typeof e.stack === 'string' &&
  typeof e.message === 'string';

const isFunction = (obj) => typeof obj === 'function';

const checkWithinSections = (sections, selectedSections) => {
  return sections.some((_section) => {
    return selectedSections.includes(_section.code);
  });
};

const checkSurrogatePair = (str) =>
  str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g);

const checkShowVoucherTooltip = (key, vouchers) => {
  if (
    vouchers.length === 0 ||
    !Boolean(vouchers[0]) ||
    vouchers[0].isUsed ||
    vouchers[0].isExpired
  ) {
    return false;
  }
  const latestAvaliableVoucher = LocalStorage.getItem(key, null);
  if (parseInt(latestAvaliableVoucher, 10) !== vouchers[0].id) {
    LocalStorage.setItem(key, vouchers[0].id);
    return true;
  } else {
    return false;
  }
};

export default {
  isEqual,
  isEmpty,
  isNull,
  isNumeric,
  isError,
  isFunction,
  checkWithinSections,
  checkSurrogatePair,
  checkShowVoucherTooltip,
};



// WEBPACK FOOTER //
// ./src/app/utils/validators.js